import React, { useEffect, useState } from "react";
import DynamicTable from "../../../layout/DynamicTable/DynamicTable";
import { action, controller } from "../../../api/api";
import Header from "./Header";
import { formatDecimal } from "../../../hooks/Method";
import { IconButton, Tooltip } from "@mui/material";
import { RemoveRedEyeRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const CreditCustomer = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [tblData, setTblData] = useState([]);

  const handleView = (val) => {
    navigate(`/view_customer/${val.customerId}`);
  };

  const ActionComp = (val) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      <Tooltip title="View Customer Profile">
        <IconButton
          onClick={() => handleView(val)}
          size="small"
          color="primary"
        >
          <RemoveRedEyeRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>
    </div>
  );

  useEffect(() => {
    setTblData([
      ...reports.map((r) => ({
        ...r,
        customer: (
          <div className="flex flex-col">
            <span className="font-medium">{r.customerName}</span>
            <span className="text-[12px]">{r.customerCode}</span>
          </div>
        ),
        contact: (
          <div className="flex flex-col text-[14px] font-medium">
            <a href={`tel:${r.phone}`}>{r.phone}</a>
            <a href={`mailto:${r.email}`}>{r.email}</a>
          </div>
        ),
        totalCredit: (
          <span className="font-medium text-red-500">
            $ {formatDecimal(r.totalCredit, true)}
          </span>
        ),
        lastCredit: (
          <div className="flex flex-col">
            <span>{r.cashierName}</span>
            <span className="text-[12px]">{r.lastCreditDate}</span>
          </div>
        ),
      })),
    ]);

    return () => {};
  }, [reports]);

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setReports}
        enableDateRange={true}
        enableExport={true}
        exportEndpoint={controller.Report + action.ExportCreditCustomer}
        endpointKey={controller.Report + action.CreditCustomer}
        ActionComp={ActionComp}
        HeaderComp={() => <Header />}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "customer", label: "customer" },
          { id: "contact", label: "Contact" },
          { id: "totalCredit", label: "Total Credit" },
          { id: "lastCredit", label: "Last Credit Made" },
        ]}
      />
    </>
  );
};

export default CreditCustomer;
